import React, { useState } from "react";
import Plot from "react-plotly.js";
import { Select, Row, Typography, Space } from "antd";

const { Option } = Select;

const OneToMany = ({ data, titlePrefix = "", gradient = true, color = "rgba(60, 120, 216, 0.5)",
                    showCircles=true}) => {
  // Extract unique tickers for dropdown
  const uniqueTickers = [...new Set(data.map((item) => item.x))];

  // State for selected ticker
  const [selectedTicker, setSelectedTicker] = useState(uniqueTickers[0]);

  // Filter data based on selected ticker
  const filteredData = data.filter((item) => item.x === selectedTicker);

  // Prepare data for the polar chart
  const tickers = filteredData.map((item) => item.y);
  const values = filteredData.map((item) => item.value);

  // Determine the fill and marker color
  const fillColor = gradient
    ? `radial-gradient(circle, ${color} 0%, rgba(255, 255, 255, 0.1) 100%)`
    : color;

  return (
    <div style={{ padding: "20px" }}>
        <Space align={'center'}>
            <Select
                defaultValue={selectedTicker}
                style={{ width: 140 }}
                onChange={(value) => setSelectedTicker(value)}
              >
                {uniqueTickers.map((ticker) => (
                  <Option key={ticker} value={ticker}>
                    {ticker.toUpperCase()}
                  </Option>
                ))}
              </Select>
        </Space>
      {/* Dropdown for ticker selection */}

      {/* Plotly Polar Chart */}
      <Plot
        data={[
          {
            type: "scatterpolar",
            r: values,
            theta: tickers,
            mode: "lines+markers",
            fill: "toself",
            fillcolor: color,
            marker: {
              color: color,
              opacity: 0.8,
              size: 10, // Adjust marker size
            },
            line: {
              color: color,
              width: 2, // Adjust line thickness
            },
          },
        ]}
        layout={{
          responsive: true,
          autosize: true,
          margin: { t: 30, l: 20, r: 20, b: 20 }, // Remove excess padding
          polar: {
            angularaxis: {
              rotation: 90,
              direction: "clockwise",
                linecolor: showCircles ? 'rgba(200, 200, 200, 0.3)' : '#fff',
              gridcolor: "rgba(200, 200, 200, 0.3)", // Light grid color
            },
            radialaxis: {
              visible: true,
              range: [0, 1],
              gridcolor: showCircles?'rgba(200, 200, 200, 0.3)':'#fff', // Make the outer ring almost invisible
              linecolor: "rgba(200, 200, 200, 0.3)", // Light radial lines
            },
          },
          showlegend: false,
        }}
        config={{ responsive: true }}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default OneToMany;
